<script setup lang="ts">
import StatusBadge from '@/components/badges/StatusBadge.vue'
import { useReference } from '@/core/composables/useReference'
import { toRefs } from 'vue'

interface Props {
  reference: ReferenceInterface
}

const props = defineProps<Props>()

const { reference } = toRefs(props)

defineOptions({
  name: 'ReferenceStatusBadge'
})

const {
  referenceAmount,
  statusIcon: icon,
  statusVariant: variant
} = useReference(reference)
</script>

<template>
  <StatusBadge :variant :icon :text="referenceAmount" />
</template>
